import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, ResponsiveMode, mergeStyleSets } from '@fluentui/react';

import NumericField from 'src/components/base/NumericField';

const PERIOD_AM = 'am';
const PERIOD_PM = 'pm';

const classNames = mergeStyleSets({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    selectors: {  
      '& > *': {
        minWidth: 0,
        marginRight: 8,
      },
      '& > :last-child': {
        minWidth: 70,
        marginRight: 0,
      },
    },
  },
})

const TimeField = ({ value, onChange }) => {
  const [date, setDate] = useState({ hours: 4, mins: 0, period: PERIOD_AM });
  useEffect(() => { setDate(parseTime(value)) }, [value]);

  function handleChange(value) {
    const hours = (value.period === PERIOD_PM && value.hours < 12)
      ? (value.hours + 12)
      : ((value.period === PERIOD_AM && value.hours === 12) ? 0 : value.hours);

    onChange(`${hours.toString().padStart(2, '0')}:${value.mins.toString().padStart(2, '0')}`);
  }

  return (
    <div className={classNames.root}>
      <div>
        <NumericField min={1} max={12}
          value={date.hours} onChange={hours => handleChange({ ...date, hours })}
        />
      </div>
      <span>:</span>
      <div>
        <NumericField min={0} max={59} pad={2}
          value={date.mins} onChange={mins => handleChange({ ...date, mins })}
        />
      </div>
      <Dropdown
        selectedKey={date.period}
        onChange={(_, value) => handleChange({ ...date, period: value.key })}
        responsiveMode={ResponsiveMode.large}
        options={[
          { key: PERIOD_AM, text: 'AM' },
          { key: PERIOD_PM, text: 'PM' },
        ]} />
    </div>
  )
}

function parseTime(time) {
  const [h, mins] = time.split(':');
  return {
    hours: h % 12 || 12,
    mins: +mins,
    period: (h < 12 || h === 24) ? PERIOD_AM : PERIOD_PM,
  };
}

TimeField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default TimeField;